export const tabsTokens = {
  'tab-height': '40px',
  'tab-padding-x': 'var(--dp-spacing-md)',
  'tab-font-size': 'var(--dp-font-size-md)',
  'tab-font-weight': 'var(--dp-font-weight-medium)',
  'tab-active-color': 'var(--dp-color-primary)',
  'tab-active-border-color': 'var(--dp-color-primary)',
  'tab-active-border-width': '2px',
  'tab-inactive-color': 'var(--dp-color-text-secondary)',
  'tab-hover-color': 'var(--dp-color-text)',
  'tab-hover-bg': 'var(--dp-color-surface-hover)',
  'tab-gap': 'var(--dp-spacing-xs)',
  'tab-border-bottom': 'var(--dp-color-border)',
} as const;
